import React, { useState } from 'react'; // Ensure this is at the top
import "./footer-content.css";
import OneTrustIntegration from '../onetrust-integration/onetrust-integration.js';

const FooterContentComponent = () => {

    const handleConsentSettingsClick = () => {
        // Trigger the OneTrust dialog
        if (window.OneTrust) {
            window.OneTrust.ToggleInfoDisplay();
        }
    };

    const version = window.env.APP_VERSION;

    return (
        <footer className="footer-layout">
          {/* <OneTrustIntegration /> */}
            <div>
                {new Date().getFullYear()} &copy; - All Rights Reserved. | 
                <a 
                    id="ot-sdk-btn-footer" 
                    className="ot-sdk-show-settings footer-consent" 
                    onClick={handleConsentSettingsClick} 
                >
                    Consent Settings
                </a>
            </div>
            <div className="footer-content">DHL - Asia Pacific Information Services MRT Version {version}</div>
            {/* <OneTrustIntegration /> Include the OneTrustIntegration component */}
        </footer>
    );
};

export default FooterContentComponent;